module.exports = __webpack_public_path__ + "static/banner-mobile-a26a3f75355d8df3ce2ba091621dd0cc.svg";